import { DrawAction, DrawActionElement } from '../draw-action';

export class FreehandDrawAction extends DrawAction {

    drawActionElement: DrawActionElement = DrawActionElement.FREEHAND;
}
